import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { PresetSheet } from "@/components/create/explore/PresetSheet";
import { SearchOverlay } from "@/components/create/explore/SearchOverlay";
import { StudioContext } from "@/lib/studio";

const typing = (el) => el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);

export default function CreateLayout() {
  const [searchOpen, setSearchOpen] = useState(false);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "/" && !e.metaKey && !e.ctrlKey && !typing(document.activeElement)) {
        e.preventDefault();
        setSearchOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return (
    <StudioContext.Provider value={{ openSearch: () => setSearchOpen(true) }}>
      <Outlet />
      <PresetSheet />
      <SearchOverlay open={searchOpen} onOpenChange={setSearchOpen} />
    </StudioContext.Provider>
  );
}
